export const lowercaseFirstChar = (str: string) =>
  str ? str[0].toLowerCase() + str.slice(1) : str;
